export default __webpack_public_path__ + "static/media/jordan_5.f588573e.png";